import { useQuery } from '@tanstack/vue-query';
import { getStripeInvoices } from '~/utils/stripe/invoices';
import type Stripe from 'stripe';

export const useInvoices = (stripeCustomerId: Ref<string | null>) => {
  const profileStore = useProfileStore();

  const invoicesQueryKey = computed(() => {
    return ['customer-invoices', stripeCustomerId.value];
  });

  const { data: invoices, isLoading: invoicesLoading } = useQuery({
    queryKey: invoicesQueryKey,
    queryFn: async () => {
      return await getStripeInvoices(stripeCustomerId.value!, {
        status: 'paid',
        limit: 100,
      });
    },
    enabled: computed(() => !!stripeCustomerId.value),
    staleTime: 5000,
    refetchInterval: 5000,
  });

  // Sync with store when data changes
  watch(
    invoices,
    (newInvoices) => {
      if (newInvoices) {
        profileStore.invoices = newInvoices;
      }
    },
    { immediate: true }
  );

  watch(
    invoicesLoading,
    (loading) => {
      profileStore.invoicesLoading = loading;
    },
    { immediate: true }
  );

  return {
    invoices,
    invoicesLoading,
  };
};
